const fr = {
  home: {
    biometric_label: "VÉRIFICATION D'IDENTITÉ BIOMÉTRIQUE",
    title: "Recherche Inversée de Visages",
    description:
      "Téléchargez un portrait haute résolution pour croiser les références avec les archives numériques mondiales grâce à la correspondance neurale avancée.",
    drag_drop: "Glissez-déposez votre image",
    file_formats: "Prend en charge RAW, JPEG ou PNG (Max 15 Mo)",
    select_file: "SÉLECTIONNER UN FICHIER DU SYSTÈME",
    initiate_scan: "Lancer l'Analyse Forensique",
    upload_hint: "VEUILLEZ TÉLÉCHARGER UNE IMAGE POUR CONTINUER",
    uploading: "Téléchargement",
    searching: "Analyse",
    result_title: "Résultats",
    drop_here: "Déposez l'image ici...",
    billion_faces: "Comparez avec plus d'1 milliard de visages sur internet",
    login_to_search: "Se connecter pour rechercher",
    login_required:
      "Connectez-vous ou créez un compte pour utiliser cette application",
    not_enough_tokens: "Jetons insuffisants",
    please_wait: "Veuillez patienter quelques minutes",
    leave_confirmation:
      "Un processus est en cours. Êtes-vous sûr de vouloir quitter ?",
  },
  sources: {
    section_title: "Sources Consultées",
    social_media: {
      name: "Réseaux Sociaux",
      description:
        "Références croisées sur les principaux réseaux sociaux et profils publics.",
    },
    web: {
      name: "Web",
      description:
        "Analyse le web ouvert pour les données de visage disponibles publiquement.",
    },
    scammers: {
      name: "Escrocs",
      description:
        "Correspond aux bases de données d'identité d'escrocs connus.",
    },
    sexual_offenders: {
      name: "Délinquants Sexuels",
      description:
        "Références croisées avec les registres publics d'auteurs d'infractions.",
    },
    videos: {
      name: "Vidéos",
      description:
        "Extrait et compare les visages des plateformes vidéo publiques.",
    },
    police_photos: {
      name: "Photos Policières",
      description:
        "Compare avec les bases de données de dossiers policiers accessibles au public.",
    },
    news_and_blogs: {
      name: "Actualités et Blogs",
      description:
        "Recherche dans les archives de presse, le contenu éditorial et les blogs.",
    },
  },
  header: {
    scan: "SCANNER",
    history: "HISTORIQUE",
    pricing: "TARIFS",
    account: "COMPTE",
    logout: "DÉCONNEXION",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Tous droits réservés. Vérification d'Identité de Précision.",
    privacy: "Politique de Confidentialité",
    terms: "Conditions d'Utilisation",
    docs: "Documentation",
    support: "Support",
  },
  common: {
    loading: "Chargement...",
    error: "Erreur",
    cancel: "Annuler",
    back: "Retour",
  },
  errors: {
    upload_failed: "Échec du téléchargement. Veuillez réessayer.",
    not_enough_tokens:
      "Vous n'avez pas assez de jetons pour effectuer cette recherche.",
  },
  login: {
    disclaimer:
      "Vous avez besoin d'un compte pour utiliser cette app. Nous n'envoyons pas de spam et ne partageons pas votre e-mail. Nous vous suggérons de vous connecter avec Apple pour préserver votre vie privée.",
  },
  results: {
    input_source: "SOURCE D'ENTRÉE",
    match_thumbnail: "Miniature de la correspondance",
    extraction_id: "ID D'EXTRACTION",
    scan_analysis: "Analyse du scan",
    scan_description:
      "Recherche biométrique inversée terminée. %{count} correspondances potentielles trouvées dans les registres publics et les indices sociaux.",
    col_identity_map: "CARTE D'IDENTITÉ",
    col_verification_path: "CHEMIN DE VÉRIFICATION",
    col_bio_match_score: "SCORE BIO",
    col_action: "ACTION",
    export_pdf: "Exporter PDF",
    exporting: "Génération...",
    verified: "VÉRIFIÉ",
    details: "DÉTAILS",
    details_tooltip: "Exécuter une comparaison faciale précise",
    details_loading: "Comparaison...",
    copied: "Copié !",
    copy_url: "Copier l'URL",
    displaying: "Affichage de %{count} sur %{total} détections",
  },
};

export default fr;
